// app/javascript/lib/auto_save/feedback.js

export const SUBMIT_HIGHLIGHT_CLASS = "auto-save-submit-highlight";
export const UNSAVED_MESSAGE_CLASS = "auto-save-unsaved-message";
export const UNSAVED_MESSAGE_TEXT = "You have unsaved data!";

/**
 * @param {HTMLFormElement} form
 * @param {{ message?: string }} [options]
 */
export function showUnsavedState(form, options = {}) {
  const submitButton = form.querySelector('[type="submit"]');
  if (!submitButton) return;

  submitButton.classList.add(SUBMIT_HIGHLIGHT_CLASS);

  const existingMessage = form.querySelector(`.${UNSAVED_MESSAGE_CLASS}`);
  if (!existingMessage) {
    const message = document.createElement("span");
    message.className = UNSAVED_MESSAGE_CLASS;
    message.textContent = options.message ?? UNSAVED_MESSAGE_TEXT;
    submitButton.insertAdjacentElement("afterend", message);
  }
}

/**
 * @param {HTMLFormElement} form
 */
export function clearUnsavedState(form) {
  const submitButton = form.querySelector('[type="submit"]');
  if (submitButton) {
    submitButton.classList.remove(SUBMIT_HIGHLIGHT_CLASS);
  }
  const message = form.querySelector(`.${UNSAVED_MESSAGE_CLASS}`);
  message?.remove();
}
